import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import { Meta } from 'common/components/meta';

const Forbidden1to1 = () => {
  return (
    <div className="error-page l-content">
      <Meta
        title="1-1 Project | crowdspring"
        meta={[{ name: "robots", content: "noindex,nofollow" }]}
      />
      <div id="content" className="row">
        <div className="small-16 medium-10 column error-content">
          <h1>Don't panic</h1>
          <p>
            This is a private 1to1 project. Only the client and the participant can see it.
            Explore thousands of other projects or get in touch with our support team.
          </p>
          <Link to='/explore' className="btn btn-primary">
            Explore thousands of other projects
          </Link>
          <Link to='/help/' className="btn btn-text">
            Get Help
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Forbidden1to1;



// WEBPACK FOOTER //
// ./error/components/forbidden_1_1.jsx